/**
 * Live progress of a validate-save request (`validate_progress` SSE).
 *
 * The whole compile+auto-fix loop runs inside ONE HTTP request — up to
 * 5 × 10-15s validations plus LLM fixes on large orgs — so without these
 * events the browser can only show a dead spinner for minutes (the
 * 2026-08-19 slow-save report). The backend emits one event per stage;
 * consumers (IDE save banner, artifact-card Validate) render the latest
 * while their own request is in flight.
 */

export interface ValidationProgress {
  className: string;
  stage: "validating" | "fixing";
  attempt: number;
  maxAttempts: number;
  /** Compile-error count being fixed — present on "fixing" events only. */
  errors?: number;
  /** Client receive time (ms epoch) — lets consumers ignore stale slots. */
  at: number;
}

/** One human line for the amber progress banner / card status. */
export function formatValidationProgress(p: ValidationProgress): string {
  const attempt =
    p.attempt > 0 && p.maxAttempts > 0 ? ` (attempt ${p.attempt}/${p.maxAttempts})` : "";
  if (p.stage === "fixing") {
    const n = p.errors ?? 0;
    const what = n > 0 ? `${n} compile error${n === 1 ? "" : "s"}` : "compile errors";
    return `Fixing ${what}${attempt}…`;
  }
  return `Checking ${p.className} against the org${attempt}…`;
}
